export function eventGenerator(type, payload) {
  return new CustomEvent(`cft:${type}`, {
    detail: payload
  })
}
